import React, { Component } from 'react';
import PropTypes from 'prop-types';	
import cx from 'classnames';
import GarmentContainer from './GarmentContainer/index.jsx';
import CustomizeGarment from './CustomizeGarment/index.jsx';
import Dropdown from '../Form/Dropdown/index';
import styles from './style.module.scss';

class Content extends Component {

	constructor(props) {
		super(props)
		this.state = {
			prev: null,
			next: null,
			garmentType: '',
			organizationType: ''
		}
	}

	componentWillMount() {
		this.resetComponent()
	}

	resetComponent = () => {
		this.setState({ 
			visible: false,
			selected: null, 
			index: null,
		})
	}

	onFormOpen = (garment, index) => {
		this.setState({ 
			visible: true,
			selected: garment,
			next: this.props.garments[index + 1],
			prev: this.props.garments[index - 1],
			index: index,
		})
	}

	onFormClose = () => {
		this.resetComponent()
	}

	nextGarment = () => {
		const { index } = this.state;
		this.setState({
			selected: this.state.next,
			next: this.props.garments[index + 2],
			prev: this.state.selected,
			index: this.state.index + 1,
		})
	}

	prevGarment = () => {
		const { index } = this.state;
		this.setState({
			selected: this.state.prev,
			next: this.state.selected,
			prev: this.props.garments[index - 2],
			index: this.state.index - 1,
		})
	}

	getGarments = () => this.props.garments.filter(garment => 
		garment.garmentType.includes(this.state.garmentType) &&
		garment.organizationType.includes(this.state.organizationType)
	)

	getGarmentTypes = () => {
		let gar = [];
		this.props.garments.map(garment => {
			if(!gar.includes(garment.garmentType)) {
				gar.push(garment.garmentType);
			};
		});
		let sanitized = [];
		gar.map(g => {
			sanitized.push({
				value: g,
				label: g
			});
		});
		return sanitized;
	}

	getOrganizationTypes = () => {
		let org = [];
		this.props.garments.map(garment => {
			if(!org.includes(garment.organizationType)) {
				org.push(garment.organizationType);
			};
		});
		let sanitized = [];
		org.map(o => {
			sanitized.push({
				value: o,
				label: o
			});
		});
		return sanitized;
	}

	onSelectGarmentType = (type) => {
		const garmentType = type ? type.value : "";
		this.setState({	garmentType });
	}

	onSelectOrganizationType = (type) => {
		const organizationType = type ? type.value : "";
		this.setState({ organizationType });
	}

	render() {
		const { visible, selected, next, prev } = this.state
		return (
			<div>
				<div 
					className={cx({ [styles.overlay]: visible ? true:false })}
					onClick={visible ? this.onFormClose:null}>
					<div 
						className={cx({
							[styles.container]: true,
							[styles.disabled]: visible ? true:false })}>
						
						<div className={styles.content}>
							<div className={styles.left}>
								<h1>
									<ul className={styles.heading}>
										<li>a taste</li>
										<li>of our</li>
										<li>fresh</li>
										<li>designs</li>
									</ul>
								</h1>
								<div className={styles.dropdown}>
									<Dropdown 
										placeholder="Apparel Type"
										items={this.getGarmentTypes()}
										onChange={this.onSelectGarmentType}
										clearable />
								</div>
								<div className={styles.dropdown}>
									<Dropdown
										placeholder="Organization Type"
										items={this.getOrganizationTypes()}
										onChange={this.onSelectOrganizationType}
										clearable />
								</div>
							</div>
							<div className={styles.right}>
							<GarmentContainer garments={this.getGarments()} 
								onClick={this.onFormOpen}/>
							</div>
						</div>
					</div>
				</div>
				{}
				{visible
					?
						<CustomizeGarment
							onClick={this.onFormClose}
							prevGarment={this.prevGarment}
							nextGarment={this.nextGarment}
							showNext={next ? true:false}
							showPrev={prev ? true:false}
							garment={selected} />
					:null}
			</div>
		)
	}
}

Content.propTypes = {
	garments: PropTypes.array.isRequired,
}

export default Content;